export enum SortDirection {
  ascend = "ascend",
  descend = "descend",
}

export type SortColumn = {
  columnKey: string;
  value: SortDirection;
};
